const FOOTER_LINKS = [
  {
    title: "Plataforma",
    links: [
      { label: "Iniciar sesión", href: "/login" },
      { label: "Convivencia Escolar", href: "#convivencia-escolar" },
      { label: "Equipos Psicosociales", href: "#equipos-psicosociales" },
      { label: "Gestión de Casos", href: "#gestion-casos" },
    ],
  },
  {
    title: "Información",
    links: [
      { label: "IA Institucional", href: "#ia-institucional" },
      { label: "Seguridad", href: "#" },
      { label: "Soporte", href: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Términos de uso", href: "#" },
      { label: "Privacidad", href: "#" },
      { label: "Protección de datos", href: "#" },
    ],
  },
];

export default function FooterSection() {
  return (
    <footer className="bg-foreground-950 text-white py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                <i className="ri-shield-star-line text-white text-lg" />
              </div>
              <span className="text-lg font-bold text-white tracking-tight">
                Ezer Convivencia360
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-xs">
              Plataforma inteligente de gestión de convivencia escolar para colegios y equipos psicosociales.
            </p>
          </div>

          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                      rel={link.href.startsWith("#") ? undefined : "nofollow"}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            Ezer Convivencia360 &copy; {new Date().getFullYear()} &middot; Todos los derechos reservados
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 flex items-center gap-1.5">
              <i className="ri-shield-check-line text-secondary-400" />
              Datos protegidos
            </span>
            <span className="text-xs text-foreground-500 flex items-center gap-1.5">
              <i className="ri-lock-line text-secondary-400" />
              Acceso por roles
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}